import { render, staticRenderFns } from "./customDashboardConfig.vue?vue&type=template&id=233feccd&scoped=true"
import script from "./customDashboardConfig.vue?vue&type=script&lang=js"
export * from "./customDashboardConfig.vue?vue&type=script&lang=js"
import style0 from "./customDashboardConfig.vue?vue&type=style&index=0&id=233feccd&prod&lang=scss"
import style1 from "./customDashboardConfig.vue?vue&type=style&index=1&id=233feccd&prod&scoped=true&lang=css"
import style2 from "./customDashboardConfig.vue?vue&type=style&index=2&id=233feccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233feccd",
  null
  
)

export default component.exports